import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './SessionExpiryModal.module.scss';
import { checkIfTokenExpired } from 'utils/AuthUtils/tokenUtils';

const SessionExpiryModal = () => {
  const navigate = useNavigate();
  const {
    UserStore: { isAuthenticated, handleLogout }
  } = useStore();
  const [isLoginRedirectLinkLoading] = useState(false);

  const logout = async () => {
    handleLogout();
    navigate('/');
  };

  const expiryTimeCheckInterval = setInterval(() => {
    const sessionExpiryModal = document.getElementById('session-expired-modal');
    if (
      !checkIfTokenExpired() &&
      sessionExpiryModal &&
      sessionExpiryModal.style.display !== 'none'
    ) {
      sessionExpiryModal.style.display = 'none';
    }
  }, 1000);

  useEffect(() => {
    return () => {
      clearInterval(expiryTimeCheckInterval);
    };
  }, []);

  return (
    <>
      {isAuthenticated && (
        <div className={classes.sessionExpiryModal} id="session-expired-modal">
          <div className={classes.modalContainer}>
            <div className={classes.modalContent}>
              {/* <img src={refreshScreenIcon} alt="Refresh Screen Icon" /> */}
              <div className={classes.header}>Session Expired</div>
              <div className={classes.content}>
                Your Session has been Expired, please login again
              </div>
              <Button
                loading={isLoginRedirectLinkLoading}
                className={classes.loginButton}
                onClick={logout}
              >
                Go to Login
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default observer(SessionExpiryModal);
